import React from 'react';
import BaseChart from './BaseChart';

const FractalChart = ({ data, trades, showSupertrend = false, timeframe = 5 }) => {
  console.log('FractalChart: Received data:', data?.length, 'trades:', trades?.length);

  const handleChartReady = (chart, series) => {
    console.log('FractalChart: Chart ready, adding trades and indicators');

    // Add buy/sell markers for trades
    if (trades && trades.length > 0) {
      console.log('FractalChart: Processing', trades.length, 'trades');
      
      const markers = trades.map(trade => {
        // Parse trade timestamp
        let tradeTime;
        if (trade.timestamp) {
          const date = new Date(trade.timestamp);
          tradeTime = Math.floor(date.getTime() / 1000);
        } else {
          console.warn('FractalChart: Trade missing timestamp:', trade);
          return null;
        }

        // Determine if it's a buy or sell
        const isBuy = trade.action && trade.action.toLowerCase().includes('buy');
        
        // Create detailed trade description like "NIFTY 24200 PUT @ ₹244.30"
        let tradeDescription = isBuy ? 'BUY ' : 'SELL ';
        
        if (trade.symbol_info) {
          // Extract option details from symbol_info
          const { index, strike, option_type } = trade.symbol_info;
          if (index && strike && option_type) {
            tradeDescription += `${index} ${strike} ${option_type.toUpperCase()}`;
          } else if (trade.symbol) {
            tradeDescription += trade.symbol;
          }
        } else if (trade.symbol) {
          tradeDescription += trade.symbol;
        }
        
        // Add price if available
        if (trade.price) {
          tradeDescription += ` @ ₹${trade.price.toFixed(2)}`;
        }
        
        return {
          time: tradeTime,
          position: isBuy ? 'belowBar' : 'aboveBar',
          color: isBuy ? '#22c55e' : '#ef4444', // Better green/red colors
          shape: isBuy ? 'arrowUp' : 'arrowDown',
          text: tradeDescription,
          size: 1,
        };
      }).filter(marker => marker !== null);

      console.log('FractalChart: Adding', markers.length, 'markers');
      series.setMarkers(markers);
    }

    // Add supertrend if requested and available
    if (showSupertrend && data && data.length > 0) {
      // Check if data has supertrend values
      const hasSupertrendData = data.some(item => item.supertrend !== undefined);
      
      if (hasSupertrendData) {
        console.log('FractalChart: Adding supertrend line');
        
        const supertrendSeries = chart.addLineSeries({
          color: '#ff6600',
          lineWidth: 2,
          title: 'Supertrend',
        });

        const supertrendData = data.map(item => ({
          time: Math.floor(new Date(item.timestamp).getTime() / 1000),
          value: parseFloat(item.supertrend || 0)
        })).filter(item => item.value > 0);

        supertrendSeries.setData(supertrendData);
      }
    }
  };

  return (
    <div className="fractal-chart">
      <BaseChart
        data={data}
        chartType="candlestick"
        height={500}
        timeframe={timeframe}
        onChartReady={handleChartReady}
      />
    </div>
  );
};

export default FractalChart;
